export const datecreatedProp = "datecreatedLT";
export const defaultData = {
  patientInformation: {
    inputs: [
      {
        name: "gender",
        label: "Gender",
        unit: "check",
        value: "",
        disabled: false,
      },
      {
        name: "status",
        label: "Status",
        unit: "blank",
        value: "",
        disabled: true,
      },
      {
        name: "fitForDuty",
        label: "Duty",
        unit: "check",
        value: "",
        disabled: false,
      },
    ],
  },
  leaveHistory: {
    list: [],
    medLeaveHistory: {
      daysOnBoard: 0,
      daysOffLeave: 0,
    },
    inputs: [
      {
        label: "Annual Period Start",
        name: "annualPeriodStart",
        value: "",
        unit: "day/month",
      },
      {
        label: "Annual Period End",
        name: "annualPeriodEnd",
        value: "",
        unit: "day/month",
      },
    ],
  },
  others: [
    {
      name: "Vaccinations",
      dataKey: "medVaccinations",
      headers: [
        { name: "Vaccine", width: "7.5%" },
        { name: "Details" },
        { name: "Manufacturer", width: "5%" },
        { name: "Amount", width: "7%" },
        { name: "Dose", width: "2.5%" },
        { name: "Next Dose Due", width: "11%" },
        { name: "Date Given", width: "11%" },
        { name: "Expiration Date", width: "11%" },
        { name: "Date Created", width: "10%" },
        { name: "Attachment", width: "5%" },
      ],
      rows: [
        {
          inputs: [
            { name: "vaccine", value: "", unit: "text" },
            { name: "details", value: "", unit: "text" },
            { name: "manufacturer", value: "", unit: "text" },
            { name: "amount", value: "", unit: "text" },
            { name: "doseNum", value: "", unit: "num" },
            { name: "nextDoseDue", value: "", unit: "date" },
            { name: "dateGiven", value: "", unit: "date", forwardDate: false },
            { name: "expirationDate", value: "", unit: "date" },
            { name: datecreatedProp, value: "", unit: "BLANK" },
            { name: "attachment", value: [], unit: "attachment" },
          ],
        },
      ],
    },
    {
      name: "Medication Usage",
      dataKey: "medMedicationUsage",
      headers: [
        { name: "Medication Name", width: "30%" },
        { name: "Amount" },
        { name: "Unit" },
        { name: "Acceptance", width: "20%" },
        { name: "Date Created", width: 170 },
      ],
      rows: [
        {
          inputs: [
            { name: "name", value: "", unit: "text" },
            { name: "amount", value: "", unit: "text" },
            { name: "unit", value: "", unit: "text" },
            { name: "acceptance", value: null, unit: "sig/acceptance" },
            { name: datecreatedProp, value: "", unit: "BLANK" },
          ],
        },
      ],
    },
    {
      name: "Prescriptions",
      dataKey: "medPrescriptions",
      headers: [
        { name: "Drug Name", width: "20%" },
        { name: "Dose", width: "15%" },
        { name: "Route", width: "15%" },
        { name: "Frequency", width: "20%" },
        { name: "Duration", width: "15%" },
        { name: "Date Created", width: "15%" },
      ],
      rows: [
        {
          inputs: [
            { name: "drugName", value: "", unit: "text" },
            { name: "dose", value: "", unit: "text" },
            { name: "route", value: "", unit: "text" },
            { name: "frequency", value: "", unit: "text" },
            { name: "duration", value: "", unit: "text" },
            { name: datecreatedProp, value: "", unit: "BLANK" },
          ],
        },
      ],
    },
    {
      name: "Allergies",
      dataKey: "medAllergies",
      headers: [
        { name: "Allergy", width: "30%" },
        { name: "Details" },
        { name: "Date Created", width: 170 },
      ],
      rows: [
        {
          inputs: [
            { name: "allergy", value: "", unit: "text" },
            { name: "details", value: "", unit: "text" },
            { name: datecreatedProp, value: "", unit: "BLANK" },
          ],
        },
      ],
    },
    {
      name: "Hearing Tests",
      dataKey: "medHearingTests",
      headers: [
        { name: "Test Date", width: "15%", input: "currentdate" },
        { name: "Results / Comments", input: "data" },
        { name: "Next Test Date", width: "15%", input: "nextdate" },
      ],
      rows: [
        {
          inputs: [
            { name: "currentdate", value: "", unit: "date" },
            { name: "data", value: "", unit: "large/text" },
            { name: "nextdate", value: "", unit: "date" },
          ],
        },
      ],
    },
    {
      name: "Medical Card",
      dataKey: "medMedicalCard",
      standalone: true,
      headers: [],
      rows: [
        {
          inputs: [
            {
              label: "Emergency Contact Person",
              name: "emergencyContact",
              value: "",
              unit: "text",
            },
            {
              label: "Contact Number",
              name: "emergencyContactNumber",
              value: "",
              unit: "text",
            },
            {
              label: "Doctors Name",
              name: "doctorsName",
              value: "",
              unit: "text",
            },
            {
              label: "Contact Number",
              name: "doctorsNumber",
              value: "",
              unit: "text",
            },
          ],
        },
      ],
    },
  ],
};
export const sectionKeys = [
  "medVaccinations",
  "medMedicationUsage",
  "medPrescriptions",
  "medAllergies",
  "medHearingTests",
  "medMedicalCard",
];
